module.exports = __webpack_public_path__ + "static/media/Icon-alignment.5d0534fb.svg";